(function () {
  'use strict';

  // Fallback for blocks/companion-product-button.liquid: re-resolves the
  // companion product live via the Storefront API when Liquid's server-side
  // metafield reference dereference came back empty (e.g. right after the
  // referenced product's inventory/shipping settings changed and the
  // server-side render is still catching up).
  const QUERY = `
    query GetCompanionProduct($id: ID!) {
      node(id: $id) {
        ... on Product {
          title
          handle
          onlineStoreUrl
        }
      }
    }
  `;

  async function resolveCompanionProduct(el) {
    const shopDomain = el.dataset.shopDomain;
    const storefrontToken = el.dataset.storefrontToken;
    const productGid = el.dataset.productGid;

    if (!shopDomain || !storefrontToken || !productGid) {
      el.remove();
      return;
    }

    const endpoint = `https://${shopDomain}/api/2025-01/graphql.json`;

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': storefrontToken,
        },
        body: JSON.stringify({ query: QUERY, variables: { id: productGid } }),
      });

      if (!response.ok) throw new Error('Network error');

      const { data } = await response.json();
      const product = data?.node;
      const url = product && (product.onlineStoreUrl || (product.handle ? `/products/${product.handle}` : null));

      if (!url) {
        el.remove();
        return;
      }

      const link = document.createElement('a');
      link.href = url;
      link.className = el.dataset.class || '';
      link.textContent = el.dataset.label || '';
      const style = el.getAttribute('style');
      if (style) link.setAttribute('style', style);

      el.replaceWith(link);
    } catch (error) {
      console.error('Error resolving companion product via Storefront API:', error);
      el.remove();
    }
  }

  document.querySelectorAll('[data-companion-fallback]').forEach(resolveCompanionProduct);
})();
